<template>
  <el-dialog :title="title" :visible.sync="dialogVisible">
    <el-form :model="form">
      <el-form-item label="Comment">
        <el-input
          v-model="form.comment"
          autocomplete="off"
          placeholder="custom_"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('onClose', true)" type="text" class="px-4"
        >CANCEL</el-button
      >
      <el-button @click="$emit('onClose', true)" type="primary">OK</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: { type: String },
    showDialog: { type: Boolean, required: true },
    form: { type: [Array, Object] }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  watch: {
    dialogVisible: {
      deep: true,
      handler(val) {
        if (!val) {
          this.$emit('onClose', val)
        }
      }
    },
    showDialog: {
      deep: true,
      handler(val) {
        this.dialogVisible = val
      }
    }
  },
  mounted() {}
}
</script>
